import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-offer-bag',
  templateUrl: './icon-offer-bag.component.html',
  styleUrls: ['./icon-offer-bag.component.scss'],
  standalone: true,
})
export class IconOfferBagComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '20';
  @Input() height = '20';
}
